import { createAction } from "redux-actions";
import { PAGE_SIZE_10 } from "../../constants/index";
import { apiPost, apiGet, apiPut, apiDelete } from "../../api/index";
import {
  urlReworkProductSecured,
  urlReworkProductRegisterSecured,
  urlReworkProductCloseSecured,
  urlReworkProductOpenSecured,
  urlDeleteReworkProductSecured,
  urlFinishReworkProductSecured,
  urlReworkProductOutPointsSecured,
  urlAddBBReworkProduct,
  urlRemoveReworkProductItemSecured,
} from "../../api/urls";
import moment from "moment-timezone";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.type !== undefined) filter += "&type=" + filters.type;
    if (filters.itemUuid !== undefined)
      filter += "&itemUuid=" + filters.itemUuid;
    if (filters.origin !== undefined) filter += "&origin=" + filters.origin;
    if (filters.batch !== undefined) filter += "&batch=" + filters.batch;
    if (filters.destination !== undefined)
      filter += "&destination=" + filters.destination;
    if (filters.dateInit) {
      const dateInit = moment(filters.dateInit);
      filter += "&dateInit=" + dateInit.valueOf();
    }
    if (filters.dateEnd) {
      const dateEnd = moment(filters.dateEnd);
      filter += "&dateEnd=" + dateEnd.valueOf();
    }
    if (filters.varietyItemCodeProcessed !== undefined)
      filter += "&varietyItemCodeProcessed=" + filters.varietyItemCodeProcessed;
  }
  if (sort) filter += "&sort=" + sort;

  return filter;
};

/**
 * Filter list orders.
 */
export const filterReworkProduct = createAction(
  "FILTER_REWORK_PRODUCT",
  (filter, param) =>
    apiGet(
      urlReworkProductSecured + generateFilterQuery(filter),
      param,
      true,
    )(),
);

/**
 * Filter list orders.
 */
export const getReworkProduct = createAction("GET_REWORK_PRODUCT", (param) =>
  apiGet(urlReworkProductSecured, param, true)(),
);

/**
 * Filter list orders.
 */
export const getReworkProductOpen = createAction(
  "GET_REWORK_PRODUCT_OPEN",
  () => apiGet(urlReworkProductOpenSecured, undefined, true)(),
);

/**
 * Register process.
 */
export const register = createAction("ENTRY_REGISTER", (obj) =>
  apiPost(urlReworkProductRegisterSecured, obj, undefined)(),
);

/**
 * Block order.
 */
export const closeReworkProductProd = createAction(
  "CLOSE_REWORK_PRODUCT",
  (obj, param) => apiPut(urlReworkProductCloseSecured, obj, param, true)(),
);

/**
 * Finish.
 */
export const removeReworkProduct = createAction(
  "FINISH_REWORK_PRODUCT",
  (param) => apiDelete(urlDeleteReworkProductSecured, param, true)(),
);

/**
 * Finish.
 */
export const finish = createAction("FINISH_REWORK_PRODUCT", (param) =>
  apiPost(urlFinishReworkProductSecured, {}, param, true)(),
);

/**
 * Filter list orders.
 */
export const getOutpoints = createAction(
  "GET_REWORK_PRODUCT_OUTPOINTS",
  (param) => apiGet(urlReworkProductOutPointsSecured, param, true)(),
);

export const addBB = createAction("REGISTER_BB", (obj, param) =>
  apiPost(urlAddBBReworkProduct, obj, param, true)(),
);

export const remove = createAction("REMOVE_RWORK_PRODUCT_ITEM", (param) =>
  apiDelete(urlRemoveReworkProductItemSecured, param, true)(),
);
